// src/hooks/useAvatarRive.js
import { useMemo } from "react";
import { useRive } from "@rive-app/react-canvas";

export function useAvatarRive(avatar = "bella", stateMachine = "State Machine 1") {
  const avatarPath = useMemo(() => {
    const safe = String(avatar || "bella").toLowerCase().trim();
    return `/avatar/${safe}-avatar.riv`;
  }, [avatar]);

  // Returns: { rive, RiveComponent, ... }
  return useRive({
    src: avatarPath,
    stateMachines: stateMachine,
    autoplay: true,
  });
}
